import React from "react"

import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

// AuthProvider is the "React Context" containing the user information being returned from the firebase
import { AuthProvider } from "../contexts/AuthContext"

import Chats from "./Chats"
import Login from "./Login"

function App() {
  return (
    <div style={{ fontFamily: 'Avenir' }}>
      <Router>
        {/* Context (for us, AuthProvider) is a big javascript object which contains data (for us, user data) & 
        wraps all the other components (Login, Chats). It is also reponsible for handling the 
        STATES (loading, user {inside AuthContext.js}) of the entire application (Cryptomania) */}
        <AuthProvider>
          <Switch>
            <Route path="/chats" component={Chats} />
            <Route path="/" component={Login} />
          </Switch>
        </AuthProvider>
      </Router>
    </div>
  )
}

export default App